import jQuery from 'jquery';
import find from 'lodash/find';

const placements = ['bottom', 'left', 'top', 'right'];

export default {
  inserted(el, { value, modifiers }) {
    // Only allow predefined placements
    const placement = find(placements, val => val in modifiers) || placements[0];

    jQuery(el).tooltip({
      title: () => value || el.title,
      animation: false,
      placement,
      html: modifiers.html,
      container: 'body',
      trigger: 'hover',
      delay: {
        show: 300,
        hide: 0,
      },
    });
  },

  componentUpdated(el, { value, oldValue }) {
    if (value !== oldValue) {
      el.dataset.originalTitle = value;
    }
  },

  unbind(el) {
    jQuery(el).tooltip('destroy');
  },
};



// WEBPACK FOOTER //
// ./resources/assets/js/directives/tooltip.js